import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, User, ArrowRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/blog`);
        setPosts(response.data);
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-maroon text-xl">Loading blog posts...</p>
      </div>
    );
  }

  return (
    <div className="py-16" data-testid="blog-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl sm:text-6xl font-heading font-bold text-maroon mb-6">
            Travelers' Blog
          </h1>
          <p className="text-xl text-maroon/70 max-w-3xl mx-auto">
            Stories, tips, and inspiration from our adventures around the world.
          </p>
        </div>

        {posts.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-xl text-maroon/70">No blog posts yet. Check back soon for travel stories and tips!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((post, idx) => (
              <Link 
                key={post.id} 
                to={`/blog/${post.id}`}
                className="card group"
                data-testid={`blog-post-${idx}`}
              >
                <div className="aspect-[16/10] mb-4 overflow-hidden rounded-sm border border-maroon/10">
                  <img 
                    src={post.image_url} 
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <h3 className="font-heading font-bold text-xl text-maroon mb-2 line-clamp-2">{post.title}</h3>
                <p className="text-maroon/70 text-sm mb-4 line-clamp-3">{post.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-maroon/60">
                  <span className="flex items-center space-x-1">
                    <User size={14} />
                    <span>{post.author}</span>
                  </span>
                  <span className="flex items-center space-x-1">
                    <Calendar size={14} />
                    <span>{new Date(post.created_at).toLocaleDateString()}</span>
                  </span>
                </div>
                <div className="mt-4 flex items-center space-x-1 text-terracotta font-semibold text-sm">
                  <span>Read More</span>
                  <ArrowRight size={16} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;